import type { ChatCompletionMessageParam } from "openai/resources";
import { z } from "zod";

export const WebCrawlerEventDetail = z.object({
  type: z.literal("webcrawler.webpage"),
  target: z.enum(["openai.chatcompletion"]).optional(),
  userId: z.string(),
  brandId: z.string(),
  data: z.object({
    url: z.string().url(),
    chatCompletion: z.custom<ChatCompletionMessageParam>().array().optional(),
  }),
});

export type WebCrawlerEventDetail = z.infer<typeof WebCrawlerEventDetail>;

const PageTypeEnum = z.enum(["product", "article", "blog", "unknown"]);

const ImageSchema = z.object({
  src: z.string(),
  width: z.number(),
  height: z.number(),
  importance: z.number().optional(),
});

export const OGDataSchema = z.object({
  type: z.string().optional(),
  title: z.string().optional(),
  description: z.string().optional(),
  images: z.string().url().array(),
  price: z
    .object({ amount: z.number().optional(), currency: z.string().optional() })
    .optional(),
});

export const HeadDataSchema = z.object({
  description: z.string().optional(),
  title: z.string().optional(),
  ogData: OGDataSchema,
});

export const WebPageSchema = z.object({
  url: z.string().url(),
  title: z.string().optional(),
  og_title: z.string().optional(),
  description: z.string().optional(),
  og_description: z.string().optional(),
  twitter_description: z.string().optional(),
  h1: z.string().optional(),
  h2: z.string().optional(),
  h3: z.string().optional(),
  body: z.string().optional(),
  content: z.string().optional(),
  images: ImageSchema.array(),
});

export type WebPage = z.infer<typeof WebPageSchema>;
